"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _isEmpty(value, errorMessage) {
  if (!value) {
    return errorMessage;
  } else if ((0, _isEmpty2.default)(value)) {
    return errorMessage;
  } else if (value === '') {
    return errorMessage;
  }
}

function _ifCond(cond, errorMessage) {
  if (cond) {
    return errorMessage;
  }
}

function _ifNotCond(cond, errorMessage) {
  if (!cond) {
    return errorMessage;
  }
}

function _use(value, fn) {
  return fn(value);
}

var ValidationWrapper =
/*#__PURE__*/
function () {
  function ValidationWrapper(value, errorMessage) {
    _classCallCheck(this, ValidationWrapper);

    this.value = value;
    this.errorMessage = errorMessage;
  }

  _createClass(ValidationWrapper, [{
    key: "isEmpty",
    value: function isEmpty(errorMessage) {
      var defaultErrorMessage = 'This field cannot be empty';

      if (this.errorMessage) {
        return new ValidationWrapper(this.value, this.errorMessage);
      }

      return new ValidationWrapper(this.value, _isEmpty(this.value, errorMessage || defaultErrorMessage));
    }
  }, {
    key: "use",
    value: function use(fn) {
      if (this.errorMessage) {
        return new ValidationWrapper(this.value, this.errorMessage);
      }

      return new ValidationWrapper(this.value, _use(this.value, fn));
    }
  }, {
    key: "ifCond",
    value: function ifCond(cond, errorMessage) {
      if (this.errorMessage) {
        return new ValidationWrapper(this.value, this.errorMessage);
      }

      if (typeof cond === 'function') {
        return new ValidationWrapper(this.value, _ifCond(cond(this.value), errorMessage));
      } else {
        return new ValidationWrapper(this.value, _ifCond(cond, errorMessage));
      }
    }
  }, {
    key: "ifNotCond",
    value: function ifNotCond(cond, errorMessage) {
      if (this.errorMessage) {
        return new ValidationWrapper(this.value, this.errorMessage);
      }

      if (typeof cond === 'function') {
        return new ValidationWrapper(this.value, _ifNotCond(cond(this.value), errorMessage));
      } else {
        return new ValidationWrapper(this.value, _ifNotCond(cond, errorMessage));
      }
    }
  }]);

  return ValidationWrapper;
}();

var _default = ValidationWrapper;
exports.default = _default;